module.exports = __webpack_public_path__ + "media/customizations/everbe/back-9d439a641747d52c16862378488912fc.jpg";